<template>
  <img :src="freshSrc" v-bind="$attrs" />
</template>

<script>
export default {
  name: 'FirebaseImg',
  inheritAttrs: false,
  props: {
    src: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      freshSrc: this.src,
    }
  },
  watch: {
    src: {
      immediate: true,
      handler(newSrc) {
        this.refreshUrl(newSrc)
      },
    },
  },
  methods: {
    async refreshUrl(url) {
      if (!url) {
        this.freshSrc = ''
        return
      }
      try {
        const match = url.match(/\/o\/(.+?)\?/)
        if (match) {
          const path = decodeURIComponent(match[1])
          this.freshSrc = await this.$storage.ref(path).getDownloadURL()
        } else {
          this.freshSrc = url
        }
      } catch (e) {
        this.freshSrc = url
      }
    },
  },
}
</script>
